<bb-page-header [icon]="'bar-chart'" [title]="'USAGE_STATISTICS' | translate">
	<ul class="tabs">
		<li>
			<a class="active">
				<i class="fa fa-bar-chart"></i> {{ 'USAGE' | translate }}
			</a>
		</li>
	</ul>
</bb-page-header>

<div class="body-column" *ngIf="!loading">
	<div class="chart-wrapper">
		<h3>
			{{ 'TRAFFIC' | translate }}
		</h3>
		<bb-chart
			[type]="'bar'"
			[bbChartSettings]="{
				maxTicksLimitY: 8,
				maxLabelRotation: 0,
				labelX: 'GB'
			}"
			[datasets]="trafficDatasets"
			height="250"
		></bb-chart>
	</div>
	<div class="chart-wrapper">
		<h3>
			{{ 'STORAGE' | translate }}
			<bb-info [contents]="'HELP.GB_MONTH_INFO' | translate" [icon]="'help'" (dblclick)="showProjection = true"></bb-info>
		</h3>
		<div>
			<p [hidden]="!showProjection">
				{{ 'PROJECTED_GB_MONTH' | translate: {currentMonth: currentMonth, projectedStorage: projectedStorage} }}
			</p>
		</div>
		<bb-chart
			[type]="'bar'"
			[bbChartSettings]="{
				maxTicksLimitY: 10,
				maxLabelRotation: 0,
				labelX: 'GB',
				labelX: 'GB_MONTH' | translate
			}"
			[datasets]="storageDatasets"
			height="250"
		></bb-chart>
	</div>
</div>
